import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import Hubspot from '../../Admin/Hubspot';
import Link from '../../../Core/Link';

import { Wrapper, StyledContainer, Content, Img } from './styles';

const Hero = ({ data }) => {
  if (!data) return null;

  // * This is prismic mapped data
  // * heading {richText} data that makes up the title of the section
  // * subheading {richText} data that makes up the title of the section
  // * bannerCTAText {string} innerText for the CTA
  // * bannerCTA {obj} contains url for CTA
  // * formId {string} to check if the hubspot form should display or not
  // * foregroundImage {obj} the data for the main image that is displayed
  // * backgroundImage {obj} the data for the bg cirlce image (optional)
  // * textWidthBool {bool} Default is true, 50% widths is false
  // * circleAlignment {string} can be Top, Right, Bottom
  const {
    headingHtml,
    subheadingHtml,
    bannerCTAText,
    bannerCTA: { url: href },
    foregroundImage: { altTag },
    imageForegroundSharp,
    imageBackgroundSharp,
    imageMobileBGSharp,
    circleAlignment,
    textWidthBool,
    ctaType,
    gridImageAlignment,
    formId,
    ariaLabel,
    queryString,
    bannerCTATextSecondary,
    bannerCTASecondary,
    ctaTypeSecondary,
    ariaLabelSecondary,
  } = data;
  const circlePosition = circleAlignment ? circleAlignment.toLowerCase() : null;
  return (
    <Wrapper id="hero">
      <StyledContainer
        className={[
          'auto-margin',
          `${circlePosition}-circle`,
          !textWidthBool && 'reduced-width',
          gridImageAlignment,
        ]}
        background={
          imageBackgroundSharp ? imageBackgroundSharp.publicURL : null
        }
        img={imageForegroundSharp || null}
        mobileImg={imageMobileBGSharp ? imageMobileBGSharp.publicURL : null}
      >
        <Content>
          {ReactHtmlParser(headingHtml)}
          {ReactHtmlParser(subheadingHtml)}
          {formId ? (
            <Hubspot
              uuid={formId}
              data={bannerCTAText}
              className={`${ctaType} auto-size`}
            />
          ) : (
            <Link
              className={`${ctaType}`}
              to={href}
              ariaLabel={ariaLabel}
              queryString={queryString}
            >
              {bannerCTAText}
            </Link>
          )}
          {bannerCTASecondary && bannerCTASecondary.url && (
            <Link
              className={`${ctaTypeSecondary}`}
              to={bannerCTASecondary.url}
              ariaLabel={ariaLabelSecondary}
            >
              {bannerCTATextSecondary}
            </Link>
          )}
        </Content>
        <Img src={imageForegroundSharp} alt={altTag} />
      </StyledContainer>
    </Wrapper>
  );
};

Hero.propTypes = {
  data: PropTypes.shape().isRequired,
};

Hero.defaultProps = {};

export default Hero;
